import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CHECKOUT_URL, offerIncludes } from '../data/fono';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-teal px-3 py-5 sm:py-7" data-id="element-102" data-mp="1mn91hlinz06n">
      <div className="mx-auto max-w-2xl" data-id="element-103" data-mp="1mpd502cnhx6e">
        <p className="text-center text-[9px] font-extrabold uppercase tracking-[0.2em] text-mustard sm:text-xs" data-id="element-104" data-mp="1hph1033ye5qu">
          Special launch offer
        </p>
        <h2 className="mt-1 text-center text-xl leading-tight text-white sm:text-3xl" data-id="element-105" data-mp="u0obophu6w57">
          🗣️ FONO KIDS PRO™
        </h2>
        <p className="mt-1 text-center text-[11px] font-extrabold uppercase tracking-wide text-mint sm:text-sm" data-id="element-106" data-mp="13xkecel20o1u">
          The complete ready-to-use activity system for pediatric speech-language
          professionals
        </p>

        <a href={CHECKOUT_URL} className="mt-2.5 block" data-id="element-107" data-mp="2famsz43lf3jd">
          <img src={BOX_IMAGE} alt="FONO KIDS PRO™ complete 6-in-1 visual activity system" className="mx-auto w-full max-w-[220px] drop-shadow-2xl transition-transform duration-200 ease-soft hover:scale-[1.02]" data-id="element-108" data-mp="2add3xpk48tw2" />
        </a>

        <div className="mt-3 rounded-xl border-4 border-mustard bg-white p-3.5 text-center shadow-2xl sm:p-5" data-id="element-109" data-mp="ul4wxuyv199d">
          <p className="text-sm font-extrabold uppercase tracking-wide text-teal" data-id="element-110" data-mp="13k0171icg9a1">
            Complete 6-in-1 Visual Activity System
          </p>

          <ul className="mt-2.5 grid gap-1 text-left sm:grid-cols-2" data-id="element-111" data-mp="6v0rrj60x1g9">
            {offerIncludes.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-semibold leading-snug text-charcoal" data-id="element-112" data-mp="bt2c07f6r6tb">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-turq" aria-hidden="true" data-id="element-113" data-mp="kle3zxpy72be" />
                {item}
              </li>)}
          </ul>

          <div className="mt-3 flex items-baseline justify-center gap-2" data-id="element-114" data-mp="3o8wh2zqby9v5">
            <span className="text-lg font-bold text-charcoal/50 line-through" data-id="element-115" data-mp="vez0op1lhb0v">$97</span>
            <span className="font-display text-5xl font-black leading-none text-teal sm:text-6xl" data-id="element-116" data-mp="qh5vnzc12n26">
              $27
            </span>
          </div>

          <p className="mt-1 text-[11px] font-extrabold uppercase tracking-wide text-coral" data-id="element-117" data-mp="154qx7ot98e7z">
            🔥 Get FONO KIDS PRO™ today
          </p>

          <CTAButton href={CHECKOUT_URL} className="mt-2.5" data-id="element-118" data-mp="cgcxn4mip9ub">
            🗣️ YES! I WANT THE COMPLETE SYSTEM
          </CTAButton>

          <p className="mt-1.5 text-[11px] font-bold text-charcoal/70" data-id="element-119" data-mp="7j3axwqijca6">
            Immediate Digital Access · 🛡️ 30-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}